// aria-label.directive.ts
import { Directive, Input, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appFocus]'
})
export class FocusDirective {
    @Input() set appFocus(value: string) {
        // console.log("value", value);
        value == '' 
        ? this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '0') 
        : value == "0" ? this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '0') 
        : this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '-1');
    }

    constructor(private el: ElementRef, private renderer: Renderer2) {        
    }
}
